import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import {
  getCheckinHealthcareProgramConfig,
  getHealthcareProgramConfig
} from 'api/HealthcareProgram';

import {
  DEFAULT_HEALTHCARE_PROGRAM_CONFIG,
  HEALTHCARE_PROGRAM_QUERY_KEY
} from 'lib/constants/healthcareProgram/eligibilitySetup';

export const useHealthcareProgramConfig = ({
  enabled = true,
  checkin = false,
  appointmentId,
  ...args
} = {}) => {
  const navigate = useNavigate();

  return useQuery(
    [HEALTHCARE_PROGRAM_QUERY_KEY, { checkin, appointmentId, ...args }],
    async () => {
      const res = checkin
        ? await getCheckinHealthcareProgramConfig(navigate, { appointment_id: appointmentId })
        : await getHealthcareProgramConfig(navigate, { ...args });
      return res?.healthcare_program ?? DEFAULT_HEALTHCARE_PROGRAM_CONFIG;
    },
    {
      enabled: enabled && (checkin ? !!appointmentId : true),
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false
    }
  );
};
